import React, { Component } from 'react';
import { DialogContainer, Button } from 'react-md';

import axios from 'axios';
import http from 'http';
import https from 'https';

import PList from '../utility/PList';

import LocalDataManager from '../managers/LocalDataManager';
import PermissionManager from '../managers/PermissionManager';
import ThreadManager from '../managers/ThreadManager';
import MediaManager from '../managers/MediaManager';

import Timer from '../utility/Timer';

import LogoZ from './SVG/LogoZ';
import Nav from './Utility/Nav';
import TutorialMenu from './Utility/TutorialMenu';
import DemoFrame from './Utility/DemoFrame';
import BlastService from '../services/BlastService';
import AccountService from '../services/AccountService';
import MediaService from '../services/MediaService';


import SplashPage from './SplashPage';
import LoginPage from './LoginPage';
import MetricsPage from './MetricsPage';
import WorkspacePage from './WorkspacePage';
import StackupPage from './StackupPage';
import StackupFreePage from './StackupFreePage';
import ReportingPage from './ReportingPage';
import ChatPage from './ChatPage';
import GroupPage from './GroupPage';
import SettingsPage from './SettingsPage';
import ProfilePage from './ProfilePage';
import FeedbackPage from './FeedbackPage';

import { Link, Route, Redirect } from 'react-router-dom'

export default class App extends Component {

    constructor(props) {
        super(props);

        window.axiosInstance = axios.create({
            timeout: 180000,
            httpAgent: new http.Agent({ keepAlive: true }),
            httpsAgent: new https.Agent({ keepAlive: true }),
            maxRedirects: 10,
            maxContentLength: 50 * 1024 * 1024
        });

        window.zThread = new ThreadManager();
        window.zTimer = new Timer();
        window.zMedia = new MediaManager();

        window.PList = PList;

        this.defaultProps = {}

        let startMode = window.location.hash.substring(2);
        this.state = {
            mode: startMode,
            isLoading: (startMode != '' && startMode != 'login'),
            isConnected: true,
            isNavOpen: false,
            tutorialActive: false,
            isLoggedIn: window.localStorage["isAuthed"] === 'true',
            alertVisible: false,
            alertTitle: '',
            alertMessage: '',
            confirmVisible: false,
            confirmTitle: '',
            confirmMessage: '',
            confirmTCallback: undefined,
            confirmFCallback: undefined,
            confirmYes: "Yes",
            confirmNo: "No",
            accountInfo: null,
            picV: 0,
            isPhone: zMedia.isPhone(),
            tutorialVideos: [],
            demoActive: false,
            easterActive: false,
            isAaBiDashboardOnly: false,
            isAaBiDashboardEnabled: false,
            isOnlineStoreEnabled: false
        }

        this.dbm = new LocalDataManager();
        this.permissionManager = new PermissionManager();
        this.blastService = new BlastService(this.dbm);
        this.accountService = new AccountService();
        this.mediaService = new MediaService();

        this.mediaCallback = this.mediaCallback.bind(this);

        this.isLoggingOut = false;

        this.superInit = this.superInit.bind(this);
        this.onlineStatusFirst = this.onlineStatusFirst.bind(this);

        this.changePage = this.changePage.bind(this);
        this.logout = this.logout.bind(this);
        this.loginComplete = this.loginComplete.bind(this);
        this.initializePendo = this.initializePendo.bind(this);
        this.updateAccountInfo = this.updateAccountInfo.bind(this);
        this.onClientAccountSelect = this.onClientAccountSelect.bind(this);
        this.setOnlineStoreFeatureFlag = this.setOnlineStoreFeatureFlag.bind(this);
        this.setAaBiDashboardOnlyState = this.setAaBiDashboardOnlyState.bind(this);

        this.loadingOn = this.loadingOn.bind(this);
        this.loadingOff = this.loadingOff.bind(this);

        this.tutorialOn = this.tutorialOn.bind(this);
        this.tutorialOff = this.tutorialOff.bind(this);

        this.demoOn = this.demoOn.bind(this);
        this.demoOff = this.demoOff.bind(this);

        this.showAlert = this.showAlert.bind(this);
        this.hideAlert = this.hideAlert.bind(this);
        this.showConfirm = this.showConfirm.bind(this);
        this.hideConfirm = this.hideConfirm.bind(this);
        this.confirmAction = this.confirmAction.bind(this);

        this.handleEasterEgg = this.handleEasterEgg.bind(this);

        alert = this.showAlert;
        window.hideAlert = this.hideAlert;

        window.zconfirm = this.showConfirm;

        this.toggleNav = this.toggleNav.bind(this);

        if (this.state.isLoggedIn && (this.state.mode === 'login' || this.state.mode === '')) {
            this.state.isLoading = true;
            let tmpAccount = window.localStorage.getItem('zzAccount');
            this.initializePendo(JSON.parse(tmpAccount));
            if (tmpAccount != undefined && tmpAccount != null) {
                let tmpAccountObj = JSON.parse(tmpAccount);
                if(tmpAccountObj.isDashboardOnly) {
                    this.state.mode = 'dashboards';
                } else if (tmpAccountObj.leaderboardOnly) {
                    this.state.mode = 'leaderboard';
                } else if (tmpAccountObj.clientAccountList.length > 0) {
                    if (tmpAccountObj.clientAccountList[0].clientAccountId === "8cc35cfd-352e-4900-825e-8671e330c5da") {
                        this.state.mode = 'profile';
                    } else {
                        if (!this.state.isPhone) {
                            if (!window.hasOwnProperty('cordova')) {
                                this.state.mode = 'dashboards';
                            } else {
                                this.state.mode = 'leaderboard';
                            }
                        } else {
                            this.state.mode = 'leaderboard';
                        }
                    }
                } else {
                    this.state.mode = 'profile';
                }
            } else {
                this.state.mode = '';
                this.logout();
            }

            // this.state.mode = 'metrics';
        } else if (!this.state.isLoggedIn && this.state.mode != '') {
            this.state.mode = '';
            this.logout();
        }

        let self = this;
        this.dbm.getAuthInfo().then((auth) => {
            if (auth === undefined || auth === null) {
                self.logout();
            } else {
                self.updateAccountInfo();
            }
        });

        this.mediaService.getTutorialManifest((videos) => {
            self.setState({ tutorialVideos: videos })
        });

        zMedia.mediaCallback = this.mediaCallback;

        window.logout = this.logout;

        window.ZeeZorRunningOnDevice = document.URL.indexOf('http://') === -1 && document.URL.indexOf('https://') === -1;
    }

    componentDidMount() {
        this.dbm.getAccountInfo().then((res) => {
            this.setAaBiDashboardOnlyState();
        });
        this.dbm.getAccountInfo().then((res) => {
            this.setAaBiDashboardEnabledState();
            this.setOnlineStoreFeatureFlag();
        });
    }
    

    componentWillReceiveProps() { }

    mediaCallback(isPhone) {
        this.setState({ isPhone: isPhone });
    }

    superInit(successCallback, errorCallback, resumeCallback, pauseCallback) {

        let self = this;

        window.zzResume = () => { window.zzIsPaused = false; };
        window.zzPause = () => { window.zzIsPaused = true; };

        self.loadingOn();

        let successFunc = () => {
            if (window.localStorage["isAuthed"] != 'true') {
                self.logout();
            } else {
                self.accountService.ping(() => {
                    self.dbm.getAccountInfo().then((profileDataExist) => {
                        self.accountService.getUserInfo(profileDataExist.userId, (profileData) => {

                            self.dbm.saveAccountInfo(profileData);

                            if (successCallback) { successCallback(); }
                            if (resumeCallback) { window.zzResume = resumeCallback; }
                            if (pauseCallback) { window.zzPause = pauseCallback; }

                        }, (err) => {
                            self.loadingOff();
                        });
                    });
                }, () => {
                    if (errorCallback) { errorCallback(); }
                    self.logout();
                });
            }
        }

        self.accountService.pingOnline(() => {
            successFunc();
        }, () => {
            self.setState({ isConnected: false }, () => {
                let checkOnlineInterval = setInterval(() => {
                    self.accountService.pingOnline(() => {
                        self.setState({ isConnected: true }, () => {
                            successFunc();
                            clearInterval(checkOnlineInterval);
                        });
                    });
                }, 5000);
            });
        });




        self.dbm.getAccountInfo().then((profileDataExist) => {

            self.accountService.getUserInfo(profileDataExist.userId, (profileData) => {

                self.dbm.saveAccountInfo(profileData);



            }, (err) => {
                self.loadingOff();
            });
        });
    }

    onlineStatusFirst(successCallback) {
        let self = this;

        self.accountService.pingOnline(() => {
            successCallback();
        }, () => {
            self.setState({ isConnected: false }, () => {
                let checkOnlineInterval = setInterval(() => {
                    self.accountService.pingOnline(() => {
                        self.setState({ isConnected: true }, () => {
                            successCallback();
                            clearInterval(checkOnlineInterval);
                        });
                    });
                }, 5000);
            });
        });
    }

    changePage(page, isFromSplash) {
        let self = this;

        if (isFromSplash && this.state.mode != '') {
            return;
        }

        let didException = false;
        if (page != "leaderboard") {
            try {
                this.blastService.unsubscribeAll(() => {
                });
            } catch (e) {
                didException = true;
            }
        }

        self.setState({ isNavOpen: false, isLoading: page === 'login' ? false : true }, () => {
            setTimeout(() => {
                self.setState({ mode: page, isNavOpen: false }, () => {
                    if (didException) {
                        self.loadingOff();
                    }
                });
            }, 500);
        })

    }

    logout() {
        if (!this.isLoggingOut) {
            this.isLoggingOut = true;

            var self = this;
            window.localStorage["isAuthed"] = false;
            window.localStorage.removeItem('zzCASubmit');
            window.localStorage.removeItem('zzCAWelcomeSeen');
            self.loadingOn();
            try {
                this.blastService.unsubscribeAll(() => {
                    self.dbm.removeInfo(() => {
                        self.isLoggingOut = false;
                        self.setState({ mode: "", isLoading: false });
                    });
                }, () => {
                    self.dbm.removeInfo(() => {
                        self.isLoggingOut = false;
                        self.setState({ mode: "", isLoading: false });
                    });
                });
            } catch (e) {
                self.dbm.removeInfo(() => {
                    self.isLoggingOut = false;
                    self.setState({ mode: "", isLoading: false });
                });
            }
        }
    }

    tutorialOn(callback) {
        var self = this;
        self.setState({ tutorialActive: true, isNavOpen: false }, () => {
            if (callback) {
                callback();
            }
        });
    }

    tutorialOff(callback) {
        var self = this;
        self.setState({ tutorialActive: false }, () => {
            if (callback) {
                callback();
            }
        });
    }

    demoOn(callback) {
        var self = this;
        self.setState({ demoActive: true, isNavOpen: false }, () => {

        });
    }

    demoOff() {
        var self = this;
        self.setState({ demoActive: false }, () => {

        });
    }

    loadingOn(callback) {
        var self = this;
        this.setState({ isLoading: true }, () => {
            if (this.callbackOffTimeout) {
                clearTimeout(this.callbackOffTimeout);
            }
            if (callback) {
                self.callbackOnTimeout = setTimeout(() => {
                    callback();
                }, 250);
            }
            self.loadingTimeout = setTimeout(() => {
                if (self.state.isLoading) {
                    self.loadingOff();
                }
            }, 190000);
        });
    }

    loadingOff(callback) {
        if (this.state.isLoading && !this.isLoggingOut) {
            if (this.callbackOnTimeout) {
                clearTimeout(this.callbackOnTimeout);
            }
            if (callback) {
                self.callbackOffTimeout = setTimeout(() => {
                    callback();
                }, 250);
            }
            if (this.loadingTimeout) {
                clearTimeout(this.loadingTimeout);
                this.loadingTimeout = undefined;
            }
            this.setState({ isLoading: false });
        }
    }

    showAlert(message) {
        this.setState({
            alertVisible: true,
            alertMessage: message
        });

    }

    hideAlert() {
        this.setState({
            alertVisible: false,
            alertTitle: '',
            alertMessage: ''
        });
    }

    showConfirm(message, trueCallback, falseCallback, yesNoObject) {
        this.setState({
            confirmTCallback: trueCallback,
            confirmFCallback: falseCallback,
            confirmVisible: true,
            confirmMessage: message,
            confirmYes: yesNoObject === undefined ? "Yes" : yesNoObject.yes,
            confirmNo: yesNoObject === undefined ? "No" : yesNoObject.no
        });
    }

    hideConfirm() {
        this.setState({
            confirmTCallback: undefined,
            confirmFCallback: undefined,
            confirmVisible: false,
            confirmTitle: '',
            confirmMessage: ''
        });
    }

    confirmAction(bool) {
        if (bool) {
            if (this.state.confirmTCallback) {
                this.state.confirmTCallback();
            }
        } else {
            if (this.state.confirmFCallback) {
                this.state.confirmFCallback();
            }
        }
        this.hideConfirm();
    }

    handleEasterEgg(text) {


    }

    toggleNav() {
        this.setState({ isNavOpen: !this.state.isNavOpen });
    }

    initializePendo(accountInfo) {
        pendo.initialize({
            visitor: {
                id: accountInfo.email,   // Required if user is logged in, default creates anonymous ID
                // email:        // Recommended if using Pendo Feedback, or NPS Email
                // full_name:    // Recommended if using Pendo Feedback
                // role:         // Optional
    
                // You can add any additional visitor level key-values here,
                // as long as it's not one of the above reserved names.
                userType: accountInfo.userType,
                user_name: accountInfo.userName,
                fullName: accountInfo.firstName + ' ' + accountInfo.lastName,
                user_id: accountInfo.userId,
                allowDashboards: accountInfo.allowDashboards,
                leaderboardOnly: accountInfo.leaderboardOnly,
                language: window.navigator.language
            },
    
            account: {
                id: accountInfo.primaryClientAccount, // Required if using Pendo Feedback, default uses the value 'ACCOUNT-UNIQUE-ID'
                // name:         // Optional
                // is_paying:    // Recommended if using Pendo Feedback
                // monthly_value:// Recommended if using Pendo Feedback
                // planLevel:    // Optional
                // planPrice:    // Optional
                // creationDate: // Optional
    
                // You can add any additional account level key-values here,
                // as long as it's not one of the above reserved names.
                companyID: accountInfo.clientAccountList[0].companyID,
                pos: accountInfo.clientAccountList[0].pos,
                companyName: accountInfo.clientAccountList[0].company,
                OnlineStoreEnabled: accountInfo.clientAccountList[0].isOnlineStoreEnabled,
                AABIDashBoardEnabled: accountInfo.clientAccountList[0].isAABIDashBoardEnabled,
                AABIDashBoardOnly: accountInfo.aabiDashboardOnly
            }
        });
    }

    loginComplete() {

        window.localStorage["isAuthed"] = true;

        let self = this;
        self.setOnlineStoreFeatureFlag();
        self.dbm.getAccountInfo().then((accountInfo) => {
            self.permissionManager.setUserType(accountInfo.userType);
            self.initializePendo(accountInfo);
            self.setAaBiDashboardOnlyState();
            self.setAaBiDashboardEnabledState();
            if(accountInfo.isDashboardOnly) {
                self.updateAccountInfo(() => {
                    self.changePage("dashboards");
                });
            } else if(accountInfo.leaderboardOnly) {
                self.updateAccountInfo(() => {
                    self.changePage("leaderboard");
                });
            } else if (accountInfo.clientAccountList.length > 0) {
                self.updateAccountInfo(() => {
                    if (!this.state.isPhone) {
                        if (!window.hasOwnProperty('cordova')) {
                            self.changePage("dashboards");
                        } else {
                            self.changePage("leaderboard");
                        }
                    } else {
                        self.changePage("leaderboard");
                    }
                });
            } else {
                self.updateAccountInfo(() => {
                    self.changePage("profile");
                });
            }
        }, (err) => {

        })
    }

    updateAccountInfo(callback) {
        let self = this;
        this.dbm.getAccountInfo().then((accountInfo) => {
            if (accountInfo != undefined && accountInfo != null &&
                accountInfo.userId != undefined && accountInfo.userId != null) {
                self.accountService.getUserInfo(accountInfo.userId, (res) => {
                    self.dbm.saveAccountInfo(res).then(() => {
                        self.setState({ accountInfo: res, picV: ++self.state.picV }, () => {
                            if (callback) {
                                callback();
                            }
                        });
                    });
                });
                // self.setState({ accountInfo: accountInfo, picV: ++self.state.picV });
            }
        })
    }

    onClientAccountSelect(){   
        this.setAaBiDashboardEnabledState();
        this.setAaBiDashboardOnlyState();
        this.setOnlineStoreFeatureFlag();
    }

    setAaBiDashboardEnabledState(){        
        this.dbm.getAccountInfo().then((res) => {
            if(res.userType === 0) {
                this.setState({isAaBiDashboardEnabled: true});
            } else {
                let clientAccIx = +(zzDataCache.settings.selectedClientAccountIndex);
                if(res.clientAccountList !== undefined) {
                    this.setState({isAaBiDashboardEnabled: res.clientAccountList[clientAccIx] && res.clientAccountList[clientAccIx].isAABIDashBoardEnabled});
                }
            }
        });
    }

    setAaBiDashboardOnlyState() {
        this.dbm.getAccountInfo().then((res) => {
            if(res.aabiDashboardOnly !== undefined) {
                this.setState({isAaBiDashboardOnly: res.aabiDashboardOnly});
            }
        })
    }

    setOnlineStoreFeatureFlag() {
        this.dbm.getAccountInfo().then((res) => {
            let clientAccIx = +(zzDataCache.settings.selectedClientAccountIndex);
            if(res.clientAccountList !== undefined) {
                this.setState({isOnlineStoreEnabled: res.clientAccountList[clientAccIx] && res.clientAccountList[clientAccIx].isOnlineStoreEnabled});
            }
        })
    }



    render() {

        try {
            let redirectUrl = "";
            if (this.state != null) {
                redirectUrl = this.state.mode;
            }

            let allowDashboards = true;
            if(this.state.accountInfo !== null) {
                allowDashboards = this.state.accountInfo.allowDashboards;

            }

            var loadingClass = "";
            if (this.state.isLoading) {
                loadingClass = 'loading-overlay--active'
            }
            if (true) {
                loadingClass += " booker-mode"
            }

            var connectedClass = null;
            if (!this.state.isConnected) {
                connectedClass = 'connected-overlay--active'
            }

            let redirect = <Redirect push to={redirectUrl} />

            let navJsx = null;
            if (this.state.mode != '' && this.state.mode != 'login') {
                navJsx = <Nav
                    accountService={this.accountService}
                    accountInfo={this.state.accountInfo}
                    picV={this.state.picV} dbm={this.dbm}
                    page={this.state.mode}
                    isOpen={this.state.isNavOpen}
                    isPhone={this.state.isPhone}
                    logout={this.logout}
                    changePage={this.changePage}
                    tutorialOn={this.tutorialOn}
                    demoOn={this.demoOn}
                    toggleNav={this.toggleNav}
                    isAaBiDashboardOnly={this.state.isAaBiDashboardOnly} 
                    />
            }

            return (
                <div id="react-outer" className={"app-outer" + (this.state.isPhone ? '' : ' app-desktop')}>
                    {redirect}

                    <Route exact path="/" render={() => (<SplashPage isPhone={this.state.isPhone} changePage={this.changePage} />)} />
                    <Route path="/login" render={() => (<LoginPage isPhone={this.state.isPhone} loadingOff={this.loadingOff} loadingOn={this.loadingOn} changePage={this.changePage} loginComplete={this.loginComplete} tutorialOn={this.tutorialOn.bind(null, undefined)} />)} />
                    <Route path="/leaderboard" render={() => (<MetricsPage isPhone={this.state.isPhone} onlineStatusFirst={this.onlineStatusFirst} superInit={this.superInit} blastService={this.blastService} loadingOff={this.loadingOff} loadingOn={this.loadingOn} logout={this.logout} changePage={this.changePage} toggleNav={this.toggleNav} handleEasterEgg={this.handleEasterEgg} />)} />
                    <Route path="/dashboards" render={() => (allowDashboards ? <WorkspacePage isOnlineStoreEnabled={this.state.isOnlineStoreEnabled} isAaBiDashboardEnabled={this.state.isAaBiDashboardEnabled} isAaBiDashboardOnly={this.state.isAaBiDashboardOnly} isPhone={this.state.isPhone} onlineStatusFirst={this.onlineStatusFirst} superInit={this.superInit} blastService={this.blastService} loadingOff={this.loadingOff} loadingOn={this.loadingOn} logout={this.logout} changePage={this.changePage} toggleNav={this.toggleNav} /> : <Redirect to={{pathname:"/leaderboard"}}/>)} />
                    <Route path="/stackup" render={() => (<StackupPage isPhone={this.state.isPhone} onlineStatusFirst={this.onlineStatusFirst} superInit={this.superInit} blastService={this.blastService} loadingOff={this.loadingOff} loadingOn={this.loadingOn} logout={this.logout} changePage={this.changePage} toggleNav={this.toggleNav} />)} />
                    <Route path="/stackupfree" render={() => (<StackupFreePage isPhone={this.state.isPhone} onlineStatusFirst={this.onlineStatusFirst} superInit={this.superInit} blastService={this.blastService} loadingOff={this.loadingOff} loadingOn={this.loadingOn} logout={this.logout} changePage={this.changePage} toggleNav={this.toggleNav} />)} />
                    <Route path="/reporting" render={() => (<ReportingPage isPhone={this.state.isPhone} onlineStatusFirst={this.onlineStatusFirst} superInit={this.superInit} blastService={this.blastService} loadingOff={this.loadingOff} loadingOn={this.loadingOn} logout={this.logout} changePage={this.changePage} toggleNav={this.toggleNav} />)} />
                    <Route path="/chat" render={() => (<ChatPage isPhone={this.state.isPhone} onlineStatusFirst={this.onlineStatusFirst} superInit={this.superInit} loadingOff={this.loadingOff} loadingOn={this.loadingOn} logout={this.logout} changePage={this.changePage} toggleNav={this.toggleNav} />)} />
                    <Route path="/groups" render={() => (<GroupPage isPhone={this.state.isPhone} onlineStatusFirst={this.onlineStatusFirst} superInit={this.superInit} loadingOff={this.loadingOff} loadingOn={this.loadingOn} logout={this.logout} changePage={this.changePage} toggleNav={this.toggleNav} />)} />
                    <Route path="/feedback" render={() => (<FeedbackPage isPhone={this.state.isPhone} onlineStatusFirst={this.onlineStatusFirst} superInit={this.superInit} loadingOff={this.loadingOff} logout={this.logout} toggleNav={this.toggleNav} />)} />
                    <Route path="/engage" render={() => (<SettingsPage isPhone={this.state.isPhone} onlineStatusFirst={this.onlineStatusFirst} superInit={this.superInit} changePage={this.changePage} loadingOff={this.loadingOff} loadingOn={this.loadingOn} logout={this.logout} toggleNav={this.toggleNav} />)} />
                    <Route path="/profile" render={() => (<ProfilePage isPhone={this.state.isPhone} onlineStatusFirst={this.onlineStatusFirst} superInit={this.superInit} changePage={this.changePage} loadingOff={this.loadingOff} loadingOn={this.loadingOn} logout={this.logout} toggleNav={this.toggleNav} updateAccountInfo={this.updateAccountInfo} onClientAccountSelect={this.onClientAccountSelect} />)} />
                    {navJsx}

                    <DialogContainer
                        id="alert-container"
                        visible={this.state.alertVisible}
                        title={this.state.alertTitle}
                        onHide={this.hideAlert}
                        actions={[
                            <Button flat primary onClick={this.hideAlert}>OK</Button>
                        ]}
                    >
                        <div className="alert-message">{this.state.alertMessage}</div>
                    </DialogContainer>
                    <DialogContainer
                        id="confirm-container"
                        visible={this.state.confirmVisible}
                        title={this.state.confirmTitle}
                        onHide={this.hideConfirm}
                        actions={[
                            <Button flat secondary onClick={this.confirmAction.bind(null, false)}>{this.state.confirmNo}</Button>
                            ,
                            <Button flat primary onClick={this.confirmAction.bind(null, true)}>{this.state.confirmYes}</Button>
                        ]}
                    >
                        <div className="alert-message">{this.state.confirmMessage}</div>
                    </DialogContainer>
                    <TutorialMenu
                        isActive={this.state.tutorialActive}
                        goAway={this.tutorialOff}
                        videos={this.state.tutorialVideos}
                    />

                    <DemoFrame active={this.state.demoActive} demoOff={this.demoOff} />

                    <div id="loading-overlay" className={loadingClass}>
                        <div class="zLoader ball-scale-multiple">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                    <div id="connected-overlay" className={connectedClass}><div>{"Disconnected"}</div><div>{"Reconnecting..."}</div></div>
                    <div className="dummy-link"><a href="#" id="dummy-link" /></div>
                </div>
            );
        } catch (ex) {
            try {

            } catch (ex) {

            }
            return <div id="react-outer">An Error Occurred. Please restart Insights</div>
        }
    }
}
